import React from "react";

const NotFound = (): JSX.Element => {
  return <div>You&apos;ve landed on a wrong planet: 404</div>;
};

export default NotFound;
